







































import Vue from "vue";
import {
  changePaymentProviderFees,
  fetchAllPaymentProviders,
  togglePaymentProviderActive
} from "@/helpers/api";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import AddPaymentModal from "@/views/academy/teamregistration/AddPaymentModal.vue";
import NewFeePaymentListItem from "@/views/payments/NewFeePaymentListItem.vue";
import { bus } from "@/main";

interface State {
  paymentProviders: any;
  isAddPaymentModalOpen: boolean;
  activeLoading: string | null;
}

export default Vue.extend({
  name: "PaymentProvidersSettings",
  components: {
    AddPaymentModal,
    NewFeePaymentListItem
  },
  data(): State {
    return {
      isAddPaymentModalOpen: false,
      paymentProviders: [],
      activeLoading: null
    };
  },
  mounted() {
    fetchAllPaymentProviders(this.$route.params.orgId).then((resp: any) => {
      this.paymentProviders = resp.data.paymentAccounts;
    });
  },
  methods: {
    updateFees(id: string, payload: any) {
      this.activeLoading = id;
      changePaymentProviderFees(id, payload)
        .then((resp: any) => {
          this.paymentProviders = resp.data.paymentAccounts;
        })
        .finally(() => {
          this.activeLoading = null;
          bus.$emit("successSnack", "Processors updated successfully");
        });
    },
    toggleActive(id: string) {
      this.activeLoading = id;
      togglePaymentProviderActive(id)
        .then((resp: any) => {
          this.paymentProviders = resp.data.paymentAccounts;
        })
        .finally(() => (this.activeLoading = null));
    },
    onPaymentAccountsChanged(data: any) {
      if (data && data.id) {
        // a new one was added, so re-fetch
        fetchAllPaymentProviders(this.$route.params.orgId).then((resp: any) => {
          this.paymentProviders = resp.data.paymentAccounts;
        });
      }
      this.isAddPaymentModalOpen = false;
    }
  },
  computed: {
    ...mapGetters({
      user: GetterTypes.GET_USER
    })
  }
});
